import React, { useState } from 'react';
import { IconButton, TextField, makeStyles, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Typography, Grid } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ShareIcon from '@material-ui/icons/Share';

import ReplyIcon from '@material-ui/icons/Reply';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import logo from "../../img/member_icon.png"
import gift from "../../img/gift_icon.png";
import moment from 'moment';
const useStyles = makeStyles(theme => ({

    board: {
        width: "270px",
        height: "335px",
        //position: "relative",
        //  display: "inline-block",
        backgroundColor: "#ffffff",
        borderRadius: "20px",
        //boxShadow: "0.05px 0.01px 1px",
        overflow: "hidden",
        margin: "1%",
        transition: "all 0.2s ease-in-out",
        "@media (max-width: 770px)": {
            width: "45%",
            height: "240px",
            margin: "0.8%",
        },

        "&:hover": {
            cursor: "pointer",
            transform: "scale(1.1)",
            boxShadow: "0 0 11px rgba(33,33,33,.2)"

        }
    },
    header_box: {
        width: "100%",
        display: "flex",
        margin: "6% 0px 6% 0px",
        alignItems: "center",
        justifyContent: "space-around"
    },

    icon: {
        width: "45px",
        height: "45px",
        background: "#f3f3f3",
        borderRadius: "100%",
        textAlign: "center",
        lineHeight: "45px",
        "@media(max-width:400px)": {
            width: "30px",
            height: "30px",
            lineHeight: "30px",

        }
    },
    name: {
        fontSize: "16px",
        fontWeight: 500,
        overflow: "hidden",
        //   textOverflow: "ellipsis",
        // whiteSpace: "nowrap",
        width: "100px",
        wordBreak: "break-all",
        WebkitLineClamp: "2",
        lineHeight: "30px",
        maxHeight: "60px",


    },
    date_box: {
        //   width: "60%",
        //marginLeft: "10%",
        // marginRight: "2%",
        textAlign: "right",
        "@media (max-width:770px)": {
            // width: "40%"
            display: "none"
        }
    },
    date1: {
        color: theme.palette.primary.main,
        // float: "right"

    },
    date2: {

        color: "#999999",
        //float: "inline-end"
    },
    body_box: {
        display: "block",
        padding: "0px 20px"
    },
    title: {
        fontSize: "22px",
        fontWeight: 500,
        lineHeight: "30px",
        width: "100%",
        minHeight: "60px",
        display: "-webkit-box box",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-all",
        WebkitLineClamp: "2",
        height: "60px",
        margin: "23px 0px 15px",
        "@media (max-width: 770px)": {
            fontSize: "16px",
            lineHeight: "20px",
            minHeight: "40px",
            height: "40px",
            margin: "15px 0px 10px",
        }
    },
    target: {
        fontSize: "17px",
        fontWeight: 500,
        width: "100%",
        maxHeight: "30px",
        display: "-webkit-box",
        overflow: "hidden",
        verticalAlign: "top",
        textOverflow: "ellipsis",
        wordBreak: "break-all",
        marginBottom: "13px",
        "@media (max-width: 770px)": {
            fontSize: "13px",
            maxHeight: "20px",
            marginBottom: "5px",
        }


    },
    content: {
        display: "-webkit-box -ms-flexbox box",
        width: "100%",
        height: "60px",
        overflow: "hidden",
        color: "#999999",
        fontSize: "14px",
        textOverflow: "ellipsis",
        lineHeight: "20px",
        verticalAlign: "top",
        wordBreak: "break-all",
        WebkitLineClamp: 3,
        "@media (max-width: 770px)": {
            fontSize: "12px",
            lineHeight: "16px",
            height: "46px",
            WebkitLineClamp: 2,
        }


    },
    footer_box: {
        //  position: "relative",
        borderTop: "1px solid #ddd",
        margin: "20px 10px 5px",
        padding: "10px 0px",
        "@media(max-width:770px)": {
            margin: "5px 10px",
            padding: "5px 0px",
        }
    },

    gift: {
        "@media (max-width: 770px)": {
            width: "16px"
        }

    },
    participate: {
        float: "right",
        color: theme.palette.primary.main,
        fontSize: 20,
        fontWeight: 500,
        "@media (max-width: 770px)": {
            fontSize: 16,
        }

    },
    dialogContent: {
        whiteSpace: 'pre-wrap',
    }



})
)

const Post = ({ title, content, date, deadline, done, comments, author, author_info, goal_participants, participants, target, with_prize, prize, num_prize, credit, num_credit }) => {

    const style = useStyles();

    const [open, setOpen] = useState(false);
    const [commentOpen, setCommentOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    //  console.log(comments)
    const menuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const menuClose = () => {
        setAnchorEl(null);
    };


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCommentOpen = () => {
        setCommentOpen(true);
    };

    const handleCommentClose = () => {
        setCommentOpen(false);
    };

    return (<>
        <div className={style.board} onClick={handleClickOpen}>
            <div className={style.header_box}>
                <div className={style.icon}>
                    <img src={logo} alt="logo" />
                </div>
                <div className={style.name}>{`${author_info || "익명"}`}</div>
                <div className={style.date_box}>
                    <div className={style.date1}>
                        {`${moment(date).format("MM.DD")}~${moment(deadline).format("MM.DD")}`}
                    </div>
                    <div className={style.date2}>
                        {`${moment(date).format("hh시mm분")}`}
                    </div>
                </div>
            </div>
            <div className={style.body_box}>
                <div className={style.title}>
                    {title}
                </div>

                <div className={style.target}>
                    {target}
                </div>

                <div className={style.content}>

                    {content}

                </div>
            </div>

            <div className={style.footer_box}>

                {with_prize && <img src={gift} alt="gift" className={style.gift} />}
                <div className={style.participate}>{`${participants}/${goal_participants}`}</div>
            </div>
        </div>
        <Dialog open={open} onClose={handleClose} fullWidth>
            <DialogTitle>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <h3>
                            {title}
                        </h3>

                    </Grid>
                    <Grid item>
                        <IconButton color="primary">
                            <ShareIcon />
                        </IconButton>
                        <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={menuClick}>
                            <MoreVertIcon />
                        </IconButton>
                        <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={menuClose}>
                            <MenuItem onClick={menuClose}>신고하기</MenuItem>
                            <MenuItem onClick={menuClose}>차단하기</MenuItem>
                            <MenuItem onClick={menuClose}>작성자에게 쪽지보내기</MenuItem>
                        </Menu>
                    </Grid>
                </Grid>

            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    리서치 대상: {target}
                    <br />
                    {with_prize && `참여보상: ${credit} 크레딧 (${num_credit}명) ${prize} ${num_prize}개`}
                </DialogContentText>
                <DialogContentText>
                    <Grid container direction="row" justifyContent="space-around" alignItems="flex-start">
                        <Grid item >
                            소요시간<br />
                            7~10분
                        </Grid>
                        <Grid item>
                            리서치 기한<br />
                            7~10분<br />
                            D-3<br />
                            <Button color="primary" fullWidth>
                                참여하기
                            </Button>
                        </Grid>
                        <Grid item>
                            리서치 진행<br />
                            7~10분<br />
                            참여 완료
                        </Grid>
                    </Grid>
                </DialogContentText>
                <DialogContentText>
                    설문조사
                </DialogContentText>
                <Typography className={style.dialogContent}>
                    {content}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={handleCommentOpen}>
                    댓글
                </Button>
                <Button color="secondary" onClick={handleClose}>
                    닫기
                </Button>
            </DialogActions>
            <Dialog open={commentOpen} onClose={handleCommentClose} fullWidth>
                <DialogTitle>
                    <h3>  댓글</h3>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {comments.map((comment, index) => {
                            return (
                                <div key={index}>
                                    <Typography>

                                        <Grid container justifyContent="space-between" alignItems="center" >
                                            <Grid item >
                                                익명|{comment.date}
                                            </Grid>
                                            <Grid item>
                                                <IconButton style={{ transform: "rotate(0.5turn)" }}>
                                                    <ReplyIcon />
                                                </IconButton>
                                                <IconButton>
                                                    <MoreHorizIcon />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                        {comment.content}
                                    </Typography>
                                    {comment.reply.map((item, index) => {
                                        return (<Typography key={index}>
                                            <Grid container justifyContent="flex-start" alignItems="flex-start" direction="row" wrap="nowrap">
                                                <Grid item>
                                                    <IconButton>
                                                        <ReplyIcon fontSize="small" style={{ transform: "rotate(0.5turn)" }} />
                                                    </IconButton>
                                                </Grid>
                                                <Grid item xs>
                                                    익명|{item.date}
                                                    <IconButton>
                                                        <MoreHorizIcon fontSize="small" />
                                                    </IconButton>
                                                    <br />
                                                    {item.content}
                                                </Grid>
                                            </Grid>
                                        </Typography>)
                                    })}
                                </div>

                            )
                        })}

                    </DialogContentText>
                    <TextField fullWidth label="댓글" />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleCommentClose}>
                        작성
                    </Button>
                    <Button color="secondary" onClick={handleCommentClose}>
                        취소
                    </Button>
                </DialogActions>
            </Dialog>
        </Dialog>
    </>
    );
};

export default React.memo(Post);